module.exports = __webpack_public_path__ + "img/switch_chain.3caf4270.png";